import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {AUTH_TOKEN} from "../../../constants/AuthConstant";
import terService from "../../../services/ref/terService";
import Cookies from "js-cookie";

export const initialState = {
    loading_ter: false,
    data_ter: [],
    showMessage:false,
    message:'',
}

export const getDataTer = createAsyncThunk('ter/data',async (data, { rejectWithValue }) => {
    try {
        const response = await terService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const terSlice = createSlice({
    name: 'ter',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_ter = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataTer.fulfilled, (state, action) => {
                state.loading_ter = false
                state.data_ter = action.payload??[]
            })
            .addCase(getDataTer.pending, (state) => {
                state.loading_ter = true
            })
            .addCase(getDataTer.rejected, (state, action) => {
                state.loading_ter = false
                state.data_ter = action.payload
            })
    },
})

export const {
    showLoading,
} = terSlice.actions

export default terSlice.reducer
